var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20663 12.4499C6.99467 10.7961 5.41835 8.97702 4.55764 7.95437C4.2912 7.6378 4.20389 7.40613 4.15141 6.99804C3.97165 5.60071 3.88179 4.90204 4.29151 4.45102C4.70125 4 5.42581 4 6.87496 4H17.1251C18.5742 4 19.2987 4 19.7084 4.45102C20.1182 4.90204 20.0283 5.60071 19.8486 6.99805C19.7961 7.40614 19.7088 7.63781 19.4423 7.95437C18.5804 8.97833 17.001 10.8006 14.7845 12.4564C14.584 12.6063 14.4518 12.8504 14.4273 13.1212C14.2077 15.5484 14.0052 16.8779 13.8792 17.5504C13.6758 18.6362 12.1362 19.2894 11.312 19.8723C10.8214 20.2192 10.226 19.8062 10.1625 19.2691C10.0413 18.2454 9.81298 16.1657 9.56379 13.1212C9.54141 12.8479 9.40876 12.601 9.20663 12.4499Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsWhite);
export default __webpack_public_path__ + "static/media/leads-white.3d17c551cbe3cfae0405e92a919c608b.svg";
export { ForwardRef as ReactComponent };